import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { Button, Tooltip } from '@wordpress/components';
import { link, linkOff } from '@wordpress/icons';
import { __ } from '@wordpress/i18n';
export default function LinkedButton(_ref) {
  let {
    isLinked,
    ...props
  } = _ref;
  const label = isLinked ? __('Unlink Radii') : __('Link Radii');
  return createElement(Tooltip, {
    text: label
  }, createElement(Button, _extends({}, props, {
    className: "component-border-radius-control__linked-button",
    isPrimary: isLinked,
    isSecondary: !isLinked,
    isSmall: true,
    icon: isLinked ? link : linkOff,
    iconSize: 16,
    "aria-label": label
  })));
}
//# sourceMappingURL=linked-button.js.map